module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.isMapping) ? _c('h3', [_vm._v("\n            Mapping Siswa\n          ")]) : _c('h3', [_vm._v("\n            Bulk Activation / Registration Upload .CSV\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('form', [_c('div', {
      staticClass: "form-horizontal form-bordered"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Duration (bulan) "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.duration),
        expression: "data.duration"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.data, "duration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("11")]), _vm._v(" "), _c('option', [_vm._v("12")])])])]), _vm._v(" "), (!_vm.isMapping) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("File "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.filename) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('p', [_vm._v(_vm._s(_vm.filename))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      attrs: {
        "id": "fileupload"
      }
    }, [_c('label', {
      staticClass: "btn btn-white"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }, [_c('input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": ".csv"
      },
      on: {
        "change": _vm.upload
      }
    })])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isMapping) ? _c('section', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12",
      staticStyle: {
        "position": "relative"
      }
    }, [(_vm.hidePass) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.default_password),
        expression: "data.default_password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "password"
      },
      domProps: {
        "value": (_vm.data.default_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "default_password", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.hidePass) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.default_password),
        expression: "data.default_password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.data.default_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "default_password", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hidePass) ? _c('i', {
      staticClass: "fa fa-eye eyeicon",
      on: {
        "click": function($event) {
          _vm.hidePass = false
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.hidePass) ? _c('i', {
      staticClass: "fa fa-eye-slash eyeicon",
      on: {
        "click": function($event) {
          _vm.hidePass = true
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.jenjang),
        expression: "jenjang"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "SD"
      }
    }, [_vm._v("SD")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "SMP"
      }
    }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "SMA"
      }
    }, [_vm._v("SMA")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.grade),
        expression: "grade"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.jenjangList), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Fitur")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column"
      }
    }, [_vm._l((_vm.featureList), function(item, index) {
      return _c('span', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.features),
          expression: "features"
        }],
        staticClass: "checkbox m-r-5",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": item,
          "checked": Array.isArray(_vm.features) ? _vm._i(_vm.features, item) > -1 : (_vm.features)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.features,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = item,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.features = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.features = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.features = $$c
            }
          }
        }
      }), _c('span', {
        staticClass: "f-s-14 f-w-700 m-r-10"
      }, [_vm._v("\n                          " + _vm._s(item === 'INSTANT_TRYOUT' ? 'Tryout Instan' : item === 'CONSULTATION' ? 'Konsultasi' : item === 'DUEL' ? 'Duel' : item === 'ITEM_BANK' ? 'Bank Soal' : item === 'SCHEDULED_TRYOUT' ? 'Tryout Terjadwal' : item === 'VIDEO' ? 'Video Pembelajaran' : item === 'BIMBEL' ? 'Bimbel' : '') + "\n                        ")])])
    }), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.featBimbel),
        expression: "featBimbel"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox",
        "value": "true"
      },
      domProps: {
        "checked": Array.isArray(_vm.featBimbel) ? _vm._i(_vm.featBimbel, "true") > -1 : (_vm.featBimbel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.featBimbel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "true",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.featBimbel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.featBimbel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.featBimbel = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v("Bimbel")])])], 2), _vm._v(" "), (_vm.featBimbel) ? _c('div', {
      staticClass: "col-md-6 col-xs-12",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column",
        "max-height": "200px",
        "overflow": "auto"
      }
    }, [_c('span', [_c('h5', [_vm._v("Pilih Daftar Bimbel")])]), _vm._v(" "), (_vm.bimbelList.length === 0) ? _c('span', [_vm._v("Tidak ada bimbel yang bisa dipilih "), _c('br'), _vm._v("Silahkan pilih kelas lain atau buat bimbel baru")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bimbelList), function(item, index) {
      return _c('span', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.bimbels),
          expression: "bimbels"
        }],
        staticClass: "checkbox m-r-5",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": item.id,
          "checked": Array.isArray(_vm.bimbels) ? _vm._i(_vm.bimbels, item.id) > -1 : (_vm.bimbels)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.bimbels,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = item.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.bimbels = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.bimbels = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.bimbels = $$c
            }
          }
        }
      }), _c('span', {
        staticClass: "f-s-14 f-w-700 m-r-10"
      }, [_vm._v(_vm._s(item.name))])])
    })], 2) : _vm._e()])]) : _vm._e()])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), (!_vm.isMapping) ? _c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "href": _vm.ossTemplate,
        "target": "_blank"
      }
    }, [_vm._v("\n              Download Example CSV\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isMapping) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": !_vm.data.duration
      },
      on: {
        "click": function($event) {
          return _vm.$emit('submitMapping', _vm.data.duration)
        }
      }
    }, [_vm._v("\n              Submit\n            ")]) : _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": !_vm.data.duration || !_vm.filename
      },
      on: {
        "click": _vm.submitBulkActivation
      }
    }, [_vm._v("\n              Submit\n            ")])]
  })], 2), _vm._v(" "), (_vm.isLoadActivationAsyncProgress) ? _c('app-spinner') : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f16ccf88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organizations/OrganizationsBulk.vue
// module id = 1400
// module chunks = 0